export default {
    state: {
        content: {},
    },

    actions: {
        LOAD_CONTENT({ commit, dispatch }, payload) {
            const { contentId, iso, submodules, moduleId, id, plan, lesson, course } = payload;
            const publicContent = payload.public ? '/public' : '';

            var module = [moduleId];

            if (moduleId === undefined) {
                module = "null";
            }

            if (submodules) {
                module = module.concat(submodules);
            }

            // Verifica se a aula é pública e caso seja, chama a rota pública
            return window.axios
                .get(`/api/app/lesson/${id}/content/${contentId}${publicContent}`, {
                    params: {
                        iso,
                        module,
                        plan,
                        lesson,
                        course,
                        lessonPublic: payload.public ? true : false
                    },
                })
                .then((res) => {
                    dispatch('SET_CONTENT', res.data);
                    commit('CLEAR_ERROR');
                })
                .catch(err => console.error(err));
        },

        SET_CONTENT({ commit }, payload) {
            commit('SET_LESSON_CONTENT', payload);

            switch (payload.type) {
            case 'exercise':
                commit('SET_EXERCISE', payload);
                break;

            default:
                break;
            }
        },
    },

    mutations: {
        SET_LESSON_CONTENT(state, payload) {
            state.content = payload;
        },
        SET_FILE_DOWNLOAD_STATUS(state, payload) {
            const { id, status } = payload;
            const newContent = state.content;

            newContent.files.forEach((file) => {
                if (file.id === id) {
                    file.download.status = status;
                }
            });

            state.content = { ...newContent };
        },
    },

    getters: {
        LOADED_CONTENT(state) {
            return state.content;
        },
    },
};
